import { unstable_composeClasses as composeClasses } from "@mui/material";
import { getTruncateListUtilityClass } from "../classes.js";
function useUtilityClasses(ownerState) {
  const { classes, className } = ownerState;
  const slots = {
    content: ["content"],
    root: ["root", className]
  };
  return composeClasses(slots, getTruncateListUtilityClass, classes);
}
export {
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
